<mat-vertical-stepper [linear]="isLinear" #stepper *ngIf="(isExtraSmall$ | async)?.matches; else horizontalStep">
  <mat-step [stepControl]="firstFormGroup" label="Measure type" matTooltip="Measure type">
    <app-measure-type [measureForm]="firstFormGroup"></app-measure-type>
    <div class="wizard-button-action">
      <button mat-button matStepperNext>Next</button>
    </div>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup" label="Target">
    <app-target [targetForm]="secondFormGroup"></app-target>
    <div class="wizard-button-action">
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button matStepperNext>Next</button>
    </div>
  </mat-step>
  <mat-step [stepControl]="thirdFormGroup" label="Alert type">
    <app-alert-type [alertTypeForm]="thirdFormGroup"></app-alert-type>
    <div class="wizard-button-action">
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button matStepperNext>Next</button>
    </div>
  </mat-step>
  <mat-step [stepControl]="fourthFormGroup" label="Notifications">
    <app-vital-flag-notification [notificationForm]="fourthFormGroup"></app-vital-flag-notification>
    <div class="wizard-button-action">
      <button mat-button matStepperPrevious>Back</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="firstFormGroup.invalid || secondFormGroup.invalid || thirdFormGroup.invalid || fourthFormGroup.invalid"
        (click)="save()"
      >
        Save
      </button>
    </div>
  </mat-step>
</mat-vertical-stepper>
<ng-template #horizontalStep>
  <mat-horizontal-stepper [linear]="isLinear" #stepper>
    <mat-step [stepControl]="firstFormGroup" label="Measure type" matTooltip="Measure type">
      <app-measure-type [measureForm]="firstFormGroup"></app-measure-type>
      <div class="wizard-button-action">
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label="Target">
      <app-target [targetForm]="secondFormGroup"></app-target>
      <div class="wizard-button-action">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup" label="Alert type">
      <app-alert-type [alertTypeForm]="thirdFormGroup"></app-alert-type>
      <div class="wizard-button-action">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="fourthFormGroup" label="Notifications">
      <app-vital-flag-notification [notificationForm]="fourthFormGroup"></app-vital-flag-notification>
      <div class="wizard-button-action">
        <button mat-button matStepperPrevious>Back</button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="firstFormGroup.invalid || secondFormGroup.invalid || thirdFormGroup.invalid || fourthFormGroup.invalid"
          (click)="save()"
        >
          Save
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</ng-template>
